/**
 * Superficies RAM que el POS tiene que re-leer al entrar (Catálogo / Stock /
 * Promos / Listas / extras). El contrato: si se actualizó en otro módulo,
 * al volver al POS tiene que verse sin F5.
 */
export const POS_LOCAL_REFRESH_SURFACES = [
  'catalog',
  'categories',
  'filters',
  'promotions',
  'priceLists',
  'menuOptions',
] as const;

export type PosLocalRefreshSurface = (typeof POS_LOCAL_REFRESH_SURFACES)[number];

export type PosLocalRefreshActions = {
  catalog: () => void | Promise<void>;
  categories: () => void | Promise<void>;
  filters: () => void;
  promotions: () => void;
  priceLists?: () => void | Promise<void>;
  menuOptions?: () => void;
};

export function shouldRefreshPosCatalogOnFocus(wasFocused: boolean, isFocused: boolean): boolean {
  return isFocused && !wasFocused;
}

export type PosCatalogSyncedRefreshPlan = 'invalidate-only' | 'refresh' | 'defer';

/**
 * Si hay un load en vuelo, no tirar el catalogSynced: ese fetch puede
 * haber leído RAM vieja y, al completar, pisa el precio nuevo.
 */
export function planPosCatalogSyncedRefresh(args: {
  isFocused: boolean;
  isInflight: boolean;
}): PosCatalogSyncedRefreshPlan {
  if (!args.isFocused) return 'invalidate-only';
  if (args.isInflight) return 'defer';
  return 'refresh';
}

/** Dispara las lecturas locales. No pega a la red. */
export function refreshPosLocalSurfaces(actions: PosLocalRefreshActions): PosLocalRefreshSurface[] {
  const ran: PosLocalRefreshSurface[] = ['catalog', 'categories', 'filters', 'promotions'];
  void Promise.resolve(actions.catalog());
  void Promise.resolve(actions.categories());
  actions.filters();
  actions.promotions();
  if (actions.priceLists) {
    void Promise.resolve(actions.priceLists());
    ran.push('priceLists');
  }
  if (actions.menuOptions) {
    actions.menuOptions();
    ran.push('menuOptions');
  }
  return ran;
}
